import React, { ButtonHTMLAttributes, ReactElement } from "react";
import styled from "styled-components";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
}

export const BaseButton: React.FC<ButtonProps> = ({ onClick, children, ...buttonProps }): ReactElement => {
    return (
        <Button {...buttonProps}>{children}</Button>
    );
};

const Button = styled.button`
    background: #e46dd669;
    width: 100%;
    border-radius: 16px;
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    padding: 16px;
    line-height: 22px;
    color: #FEFFFF;
    cursor: pointer;
    transition: background-color 0.1s ease;

    &:hover {
        background: #173c54;
        color: #E3F0E3;
    }

    @media (min-width: 768px) {
        font-size: 22px;
    }
`